import { Injectable } from "@angular/core";
import { Grid } from "@fs/enums/grid.enum";
import { TemplateModel } from "@fs/models/template.model";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { FilterProp } from "@shared/models/filterprop.model";
import { TimeZoneConverter } from "@shared/pipes/timezone-converter.pipe";
@Injectable({
    providedIn: 'root'
})
export class FsUtil {
    constructor() {}

    static getVisitsPerYear(interval: string): number {
        let count = 0;

        switch(interval) {
            case 'annual': 
                count = 1;
                break;
            case 'semiannual':
                count = 2;
                break;
            case 'triannual':
                count = 3;
                break;
            case 'quarterly':
                count = 4;
                break;
            case 'bimonthly':
                count = 6;
                break;
            case 'monthly':
                count = 12;
                break;
        }
        return count;
    }
    /**
   * Returns true if any of values is null or undefined or empty
   * @param values
   * @param checkEmpty check for empty value
   */
    static checkNullOrUndefined(values:any[], checkEmpty: boolean = false) {
        let isNullOrUndefined = false;
        
        for(let value of values) {
            if (typeof (value) == "number") {
                return isNaN(value);
            }
            if (value) {
                if (checkEmpty) {
                    if (typeof value == "string") {
                        isNullOrUndefined = value.trim() == "" || value.length == 0;
                    }
                    else {
                        isNullOrUndefined = value.length == 0;
                    }
                }
            } else isNullOrUndefined = true;
            if (isNullOrUndefined) break;
        }
        return isNullOrUndefined;
    }
    static setGridState(type: Grid, skip = 0, take = 25): DataSourceRequestState {
      return {
        skip: skip,
        take: take,
        sort: this.configSort([], type)
      }
    }
    static configSort(source = [], type:Grid) {
      switch (type) {
        case Grid.Customer:
        case Grid.JobSite: {
          source.push({ field: "Jobsite.DisplayName", dir: "asc" });
          break;
        }
        case Grid.AccountingLog: {
          source.push({ field: 'SubmittedDate', dir: 'desc' });
          break;
        }
        case Grid.Product: {
          source.push({ field: 'ItemNumber', dir: 'asc' });
          break;
        }
        case Grid.Setup: {
          source.push({ field: 'Name', dir: 'asc' });
          break;
        }
        case Grid.JobSiteWorkOrder: {
          source.push({ field: "PromisedDate", dir: "desc" });
          break;
        }
        case Grid.WorkOrder: {
          source.push({ field: "PromisedDate", dir: "asc" });
          break;
        }
        case Grid.WorkOrderReview:{
          source.push({ field: "CompletedDate", dir: "asc" });
          break;
        }
        case Grid.JobSiteEquipment: {
          source.push({ field: "InstallDate", dir: "asc" });
          break;
        } 
        case Grid.ServiceAgreement: {
          source.push({ field: "AgreementName", dir: "asc" });
          break;
        }
      }
      return source;
    }
    //This method becomes obsolete gradually(use grid.mixin instead) 
    static configFilters(source: FilterProp[], type: Grid) {
      switch (type) {
        case Grid.CustomerSearch:
          source.push(new FilterProp("First Name", "FirstName", "string"));
          source.push(new FilterProp("Last Name", "LastName", "string"));
          source.push(new FilterProp("Company Name", "CompanyName", "string"));
          source.push(new FilterProp("Display Name", "DisplayName", "string"));
          source.push(new FilterProp("Address", "Address", "string"));
          source.push(new FilterProp("Phone Number", "PhoneNumber", "string"));
          source.push(new FilterProp("Email Address", "EmailAddress", "string"));
          break;
        case Grid.Category:
          source.push(new FilterProp("All Names", "AllNames", "string"));
          source.push(new FilterProp("Category Name", "CategoryName", "string"));
          source.push(new FilterProp("Sub Category Name", "SubCategoryName", "string"));
          break;
        case Grid.TaxGroup:
          source.push(new FilterProp("Accounting Integration", "MappingCode", "string"));
          source.push(new FilterProp("Active Status", "IsActive", "Boolean"));
          source.push(new FilterProp("Tax Rate", "TaxRate", "number"));
          break;
        case Grid.Product:
          source.push(new FilterProp("Item No.", "ItemNumber", "string"));
          source.push(new FilterProp("Item Description", "Description", "string"));
          source.push(new FilterProp("Item Category", "CategoryName", "string"));
          source.push(new FilterProp("Frequently Used", "IsFrequentlyUsed", "Boolean"));
          source.push(new FilterProp("Standard Price", "StandardPrice", "number"));
          source.push(new FilterProp("Excluded from Agreement Discounts", "IsAgreementExcluded", "Boolean"));
          source.push(new FilterProp("Preferred Supplier", "PreferredSupplier", "string"));
          source.push(new FilterProp("Supplier Item", "SupplierItemNumber", "string"));
          source.push(new FilterProp("Item Type", "Type", "string"));
          source.push(new FilterProp("Note", "Note", "string"));
          break;
        case Grid.WorkOrder:
          source.push(new FilterProp("Job Site First Name", "Jobsite.FirstName", "string"));
          source.push(new FilterProp("Job Site Last Name", "Jobsite.LastName", "string"));
          source.push(new FilterProp("Job Site Company Name", "Jobsite.CompanyName", "string"));
          source.push(new FilterProp("Job Site Display Name", "Jobsite.DisplayName", "string"));
          source.push(new FilterProp("Job Site Street Address", "Jobsite.StreetNo", "string"));
          source.push(new FilterProp("Unit/Apartment", "Jobsite.Unit", "string"));
          source.push(new FilterProp("City", "Jobsite.City", "string"));
          source.push(new FilterProp("Zip Code", "Jobsite.ZipCode", "string"));
          source.push(new FilterProp("Completed Date", "CompletedDate", "daterange"));
          source.push(new FilterProp("Service Type", "ServiceType", "string"));
          source.push(new FilterProp("Technician", "TechnicianID", "MultiSelect"));
          source.push(new FilterProp("Promised Date", "PromisedDate", "daterange"));
          source.push(new FilterProp("Department", "DepartmentID", "MultiSelect"));
          source.push(new FilterProp("State", "StatusID", "MultiSelect"));
          source.push(new FilterProp("Sub State", "SubStatusID", "MultiSelect"));
          source.push(new FilterProp("Priority", "PriorityID", "MultiSelect"));
          break;
        case Grid.WorkOrderReview:
          source.push(new FilterProp("Job Site First Name", "Jobsite.FirstName", "string"));
          source.push(new FilterProp("Job Site Last Name", "Jobsite.LastName", "string"));
          source.push(new FilterProp("Job Site Company Name", "Jobsite.CompanyName", "string"));
          source.push(new FilterProp("Job Site Display Name", "Jobsite.DisplayName", "string"));
          source.push(new FilterProp("Job Site Street Address", "Jobsite.StreetNo", "string"));
          source.push(new FilterProp("Job Site Unit/Apartment", "Jobsite.Unit", "string"));
          source.push(new FilterProp("Job Site City", "Jobsite.City", "string"));
          source.push(new FilterProp("Job Site Zip Code", "Jobsite.ZipCode", "string"));
          source.push(new FilterProp("Customer Billing First Name", "Customer.FirstName", "string"));
          source.push(new FilterProp("Customer Billing Last Name", "Customer.LastName", "string"));
          source.push(new FilterProp("Customer Billing Company Name", "Customer.CompanyName", "string"));
          source.push(new FilterProp("Customer Billing Display Name", "Customer.DisplayName", "string"));
          source.push(new FilterProp("Customer Billing Street Address", "Customer.StreetNo", "string"));
          source.push(new FilterProp("Customer Billing Unit/Apartment", "Customer.Unit", "string"));
          source.push(new FilterProp("Customer Billing City", "Customer.City", "string"));
          source.push(new FilterProp("Customer Billing Zip Code", "Customer.ZipCode", "string"));
          source.push(new FilterProp("Completed Date", "CompletedDate", "daterange"));
          source.push(new FilterProp("Service Type", "ServiceType", "string"));
          source.push(new FilterProp("Technician", "TechnicianID", "MultiSelect"));
          source.push(new FilterProp("Department", "DepartmentID", "MultiSelect"));
          source.push(new FilterProp("State", "StatusID", "MultiSelect"));
          source.push(new FilterProp("Sub State", "SubStatusID", "MultiSelect"));
          source.push(new FilterProp("Outstanding Agreement(s)", "PendingAgreement", "Boolean"));
          break;
        case Grid.DispatchBoard:
          source.push(new FilterProp("State", "StatusID", "MultiSelect"));
          source.push(new FilterProp("Sub State", "SubStatusID", "MultiSelect"));
          break;
        case Grid.AccountingLog:
          source.push(new FilterProp("Submitted By", "SubmittedBy", "string"));
          source.push(new FilterProp("Command", "Command", "string", ["eq", "neq"]));
          source.push(new FilterProp("Command Response", "CommandResponse", "string", ["eq", "neq"]));
          source.push(new FilterProp("Entity", "EntityName", "string", ["b", "nb", "eq", "neq"]));
          source.push(new FilterProp("Message ", "Message", "string"));
          source.push(new FilterProp("Submission Date", "SubmittedDate", "daterange"));
          source.push(new FilterProp("Status", "TransactionStatusID", "MultiSelect"));
          break;
        case Grid.JobSite:
          source.push(new FilterProp("Accounting Integration", "IntegrationStatus", "string",null,true));
          source.push(new FilterProp("City", "City", "string",null,true));
          source.push(new FilterProp("Comment", "Comment", "string",null,true));
          source.push(new FilterProp("Company Name", "CompanyName", "string",null,true));
          source.push(new FilterProp("Contact First Name", "ContactFirstName", "string",null,true));
          source.push(new FilterProp("Contact Last Name", "ContactLastName", "string",null,true));
          source.push(new FilterProp("Contact Phone", "ContactNumber", "string",null,true));
          source.push(new FilterProp("Customer Since", "Customer.CustomerSince", "Date"));
          source.push(new FilterProp("Display Name", "DisplayName", "string",null,true));
          source.push(new FilterProp("Email", "ContactEmail", "string",null,true));
          source.push(new FilterProp("First Name", "FirstName", "string",null,true));
          source.push(new FilterProp("Last Name", "LastName", "string",null,true));
          source.push(new FilterProp("Payment Terms", "Customer.PaymentTermID", "MultiSelect"));
          source.push(new FilterProp("Status", "IsActive", "Boolean",null,true));
          source.push(new FilterProp("Street Address", "StreetNo", "string",null,true));
          source.push(new FilterProp("State", "State", "string",null,true));
          source.push(new FilterProp("Tax Code", "Jobsite.TaxGroupID", "MultiSelect"));
          source.push(new FilterProp("Type", "TypeID", "MultiSelect",null,true));
          source.push(new FilterProp("Unit/Apartment", "Unit", "string",null,true));
          source.push(new FilterProp("Zip", "ZipCode", "string",null,true));
          source.push(new FilterProp("Active Agreement", "ActiveAgreement", "Boolean"));
          break;
        case Grid.Customer: 
          source.push(new FilterProp("Accounting Integration", "IntegrationStatus", "string",null,true));
          source.push(new FilterProp("City", "City", "string",null,true));
          source.push(new FilterProp("Contact First Name", "ContactFirstName", "string",null,true));
          source.push(new FilterProp("Contact Last Name", "ContactLastName", "string",null,true));
          source.push(new FilterProp("Contact Phone", "ContactNumber", "string",null,true));
          source.push(new FilterProp("Comment", "Comment", "string",null,true));
          source.push(new FilterProp("Company Name", "CompanyName", "string",null,true));
          source.push(new FilterProp("Customer Since", "Customer.CustomerSince", "Date"));
          source.push(new FilterProp("Display Name", "DisplayName", "string",null,true));
          source.push(new FilterProp("Email", "ContactEmail", "string",null,true));
          source.push(new FilterProp("First Name", "FirstName", "string",null,true));
          source.push(new FilterProp("Last Name", "LastName", "string",null,true));
          source.push(new FilterProp("Payment Terms", "Customer.PaymentTermID", "MultiSelect"));
          source.push(new FilterProp("State", "State", "string",null,true));
          source.push(new FilterProp("Status", "IsActive", "Boolean",null,true));
          source.push(new FilterProp("Street Address", "StreetNo", "string",null,true));
          source.push(new FilterProp("Type", "TypeID", "MultiSelect",null,true));
          source.push(new FilterProp("Unit/Apartment", "Unit", "string",null,true));
          source.push(new FilterProp("Zip", "ZipCode", "string",null,true));
          break;
        case Grid.JobsiteSearch:
          source.push(new FilterProp("First Name", "FirstName", "string"));
          source.push(new FilterProp("Last Name", "LastName", "string"));
          source.push(new FilterProp("Company Name", "CompanyName", "string"));
          source.push(new FilterProp("City", "City", "string"));
          source.push(new FilterProp("State", "State", "string"));
          source.push(new FilterProp("Zip", "ZipCode", "string"));
          source.push(new FilterProp("Customer Since", "CustomerSince", "Date"));
          source.push(new FilterProp("Contact Phone Number", "PhoneNumber", "string"));
          source.push(new FilterProp("Email Address", "EmailAddress", "string"));
          source.push(new FilterProp("Active Status", "IsActive", "Boolean"));
          break;
        case Grid.CustomerLiteSearch:
          source.push(new FilterProp("First Name", "FirstName", "string"));
          source.push(new FilterProp("Last Name", "LastName", "string"));
          source.push(new FilterProp("Company Name", "CompanyName", "string"));
          source.push(new FilterProp("City", "City", "string"));
          source.push(new FilterProp("State", "State", "string"));
          source.push(new FilterProp("Zip", "ZipCode", "string"));
          source.push(new FilterProp("Customer Since", "CustomerSince", "Date"));
          source.push(new FilterProp("Contact Phone Number", "PhoneNumber", "string"));
          source.push(new FilterProp("Email Address", "EmailAddress", "string"));
          source.push(new FilterProp("Active Status", "IsActive", "Boolean"));
          break;
        case Grid.NewWorkOrder:
          source.push(new FilterProp("First Name", "FirstName", "string"));
          source.push(new FilterProp("Last Name", "LastName", "string"));
          source.push(new FilterProp("Company Name", "CompanyName", "string"));
          break;
        case Grid.ServiceAgreement: {
          source.push(new FilterProp("First Name", "FirstName", "string"));
          source.push(new FilterProp("First Name", "FirstName", "string"));
          source.push(new FilterProp("First Name", "FirstName", "string"));
        }
      }
    }
    static selectTabStrip(tabs: TemplateModel[], index = 0) {
      tabs.forEach(x => {
        if (x.Index == index) {
          x.Selected = true;  
        } else {
          x.Selected = false;
        }
      });
    }
    /**
    * Convert fitlers as to not override selected behavior
    * @param filters Actual fitlers
    */
    static parseFilters(filters: any) {
      const dateColumns = ['submitteddate'];
      for (let i = 0; i < filters.length; i++) {
        let element = Object.assign({}, filters[i]);
        if (Array.isArray(element.value)) {
          let result = [];
          element.value.forEach(element1 => {
            result.push(((element1.ID)? element1.ID : element1));
          });
          element.value = result;
        }
        else if (dateColumns.indexOf(element.field.toLocaleLowerCase()) != -1) {
          element.value = new TimeZoneConverter().transform(new Date(element.value), true);;
        }
        filters[i] = element;
      }
    }
    static getRandomId() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
}